import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { Button, ButtonGroup, Grid } from '@material-ui/core';
import ReactDOM from 'react-dom';
import { useHistory, useLocation } from 'react-router-dom';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../ReportsScreens/GijgoForReportsScreen';
import formatters from '../../../../Core/Grid/inputFormatter';
import TCardDashboardModal from '../Dashboard/T-cardModal';
import CustomerDetailsModal from '../../workflow-job/more/CustomerDetailsModal/CustomerDetailsModal';
import { AppStorage } from '../../../../Core/Service/storage-service';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Label } from 'recharts';
import AddcheckOut from './AddcheckOut';
import DialogComp from '../../../../Core/Modal/dialogModal';
import { set } from 'lodash';
import AddCheckIn from './AddCheckIn';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import AddIcon from '@material-ui/icons/Add';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import '../tCardScreenCommonStyle.scss';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'T-Card', path: '/', active: true },
    { name: 'T-Cards List', path: '/', active: true }
];

export default function TCardList() {
    const history = useHistory();
    const location = useLocation();
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const isBreakdown = queryParams.get('isBreakdown') || false;

    const rawJson = AppStorage.getTCardStatus();
    const parsed = useMemo(() => {
        try {
            return JSON.parse(rawJson);
        } catch {
            return [];
        }
    }, [rawJson]);
    const statusArray = Array.isArray(parsed) ? parsed : Object.values(parsed);

    const statusOptions = useMemo(() => statusArray.map((s) => ({ id: s.id, name: s.status })), [statusArray]);
    const dropProvider = useCallback(() => ({ StatusID: statusOptions }), [statusOptions]);

    const statusFilter = queryParams.get('StatusID') || '';
    const siteVehicleFilter = queryParams.get('SiteVehicle') || '';
    const qs = [statusFilter && `StatusID=${statusFilter}`, siteVehicleFilter && `SiteVehicle=${siteVehicleFilter}`].filter(Boolean).join('&');

    console.log(statusFilter, ' statusFilter');
    console.log(qs, ' qs');
    const [state, setState] = useState({
        show: false,
        id: null,
        refreshGrid: Date.now(),
        customerModal: { show: false, accountNo: null },
        isCollected: 'A', // Default to Active
        url: ''
    });

    const [checkTcard, setCheckTcard] = useState({
        showCheckout: false,
        tCardsID: null,
        bookingDate: null,
        selectedVehicle: null
    });

    useEffect(() => {
        let url = '';
        if (isBreakdown) {
            url = `TCards/TCards_List?hasBreakdown=true`;
        } else if (qs) {
            url = `TCards/TCards_List${qs ? `?${qs}` : ''}`;
        } else {
            url = `TCards/TCards_List${state.isCollected == 'C' ? '?StatusID=10' : ''}`;
        }
        setState((prev) => ({
            ...prev,
            url: url
        }));
    }, [state.isCollected]);

    const closeCommonModal = (_show, _id, shouldRefresh) => {
        setState((s) => ({
            ...s,
            show: false,
            id: null,
            refreshGrid: shouldRefresh ? Date.now() : s.refreshGrid
        }));
    };

    const openCustomerModal = useCallback((accountNo) => {
        setState((prev) => ({
            ...prev,
            customerModal: { show: true, accountNo }
        }));
    }, []);

    const closeCustomerModal = useCallback(() => {
        setState((prev) => ({
            ...prev,
            customerModal: { show: false, accountNo: null }
        }));
    }, []);

    const baseCols = useMemo(
        () => [
            { field: 'reg', title: 'Reg No', width: '120' },
            { field: 'cust', title: 'Customer' },
            { field: 'bn', title: 'Branch', width: '150' },
            { field: 'bd', title: 'Booking Date', renderer: formatters.YearFormatter, width: '140' },
            { field: 'arrived', title: 'Arrived', renderer: formatters.YearFormatter, width: '140' },
            { field: 'deadlinedate', title: 'Deadline Date', renderer: formatters.DateTimeFormatter, width: '140' },
            { field: 'dd', title: 'Due Date', renderer: formatters.DateTimeFormatter, width: '160' },
            { field: 'lineItems', title: 'Line Items', width: '250' },

            { field: 'oNo', title: 'Order No', width: '100' },
            { field: 'wipNumber', title: 'WIP No', width: '100' }
        ],
        [statusArray]
    );

    const regColRenderer = (field) => (value, r) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid style={{ fontWeight: 'bold', color: 'blue', cursor: 'pointer' }} onClick={() => setState((s) => ({ ...s, show: true, id: r.tCardsID }))}>
                {value}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const cutomerColRenderer = (field) => (value, r) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid style={{ fontWeight: 'bold', color: 'blue', cursor: 'pointer' }} onClick={() => openCustomerModal(r.accountNo)}>
                {value}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const WIPColRenderer = (field) => (value, r) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid
                style={{ fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}
                onClick={() => r.headerRecordID && history.push(`/Job/${r.headerRecordID}/${r.workflowID}?ProcessId=${r.processID}`)}
            >
                {value}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const handleCheckout = (row) => {
        console.log(row, ' row');

        setCheckTcard((s) => ({
            ...s,
            showCheckout: true,
            tCardsID: row.tCardsID,
            selectedVehicle: row,
            bookingDate: row.bd
        }));
        console.log(row, ' row');
    };
    const handleCheckIn = (row) => {
        setCheckTcard((s) => ({
            ...s,
            showCheckIn: true,
            selectedVehicle: row,
            tCardsID: row.tCardsID
        }));
        console.log(row, ' row');
    };
    const closeCheckout = (res) => {
        setCheckTcard((s) => ({
            ...s,
            showCheckout: false,
            tCardsID: null,
            bookingDate: null,
            showCheckIn: false,
            selectedVehicle: null
        }));

        setState((s) => ({
            ...s,
            refreshGrid: res ? Date.now() : s.refreshGrid
        }));
    };

    const handleEdit = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
                {/* {statusFilter == '1' ? (
                    <Grid item>
                        <abbr title="Check In T-Card">
                            <CheckCircleIcon style={{ cursor: 'pointer', color: 'green', fontSize: '1.2rem' }} onClick={() => handleCheckIn(record)} />
                        </abbr>
                    </Grid>
                    ) : (
                        <Grid item label="Check Out">
                        <abbr title="Check Out T-Card">
                        <ExitToAppIcon style={{ cursor: 'pointer', color: 'red', fontSize: '1.2rem' }} onClick={() => handleCheckout(record)} />
                        </abbr>
                        </Grid>
                        )} */}

                {!record.arrived ? (
                    <Grid item>
                        <abbr title="Checkin Vehicle">
                            <AirportShuttleIcon style={{ cursor: 'pointer', color: 'green', fontSize: '22px' }} onClick={() => handleCheckIn(record)} />
                        </abbr>
                    </Grid>
                ) : (
                    <Grid item>&nbsp;</Grid>
                )}
                {!record.collected ? (
                    <Grid item label="Check Out">
                        <abbr title="Checkout vehicle">
                            <ExitToAppIcon style={{ cursor: 'pointer', color: 'red', fontSize: '22px' }} onClick={() => handleCheckout(record)} />
                        </abbr>
                    </Grid>
                ) : null}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    let branchID = queryParams.get('branchID') || '';
    if (!branchID) {
        try {
            const dashboardData = JSON.parse(localStorage.getItem('_dashboard_') || '{}');
            branchID = dashboardData.branchID || '';
        } catch (e) {}
    }
    const tCardList = { branchID };

    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" alignItems="center">
                <abbr title="Create T-Card">
                    <SquareButton
                        style={{
                            backgroundColor: 'green',
                            borderRadius: '4px',
                            width: '28px',
                            height: '28px',
                            minWidth: '28px',
                            textAlign: 'center',
                            padding: '0px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer'
                        }}
                        onClick={() => history.push('/CheckInDashboard' + (tCardList.branchID ? '?branchID=' + tCardList.branchID : ''))}
                    >
                        <AddIcon fontSize="small" style={{ color: 'white', fontSize: 18 }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseCols];

        let regNumberCol = tempCols.find((element) => element.field === 'reg');
        let customerCol = tempCols.find((element) => element.field === 'cust');
        let wipNumberCol = tempCols.find((element) => element.field === 'wipNumber');

        if (regNumberCol) {
            regNumberCol.renderer = regColRenderer({});
        }
        if (customerCol) {
            customerCol.renderer = cutomerColRenderer({});
        }
        if (wipNumberCol) {
            wipNumberCol.renderer = WIPColRenderer({});
        }

        if (state.isCollected == 'A') {
            tempCols.splice(8, 0, {
                field: 'StatusID',
                title: 'Status',
                isDropDown: true,
                listIdFromAPIResponse: 'StatusID',
                dropDownValueField: 'id',
                dropDownLableField: 'name',
                filterable: true,
                sortable: true,
                width: '180',
                renderer: (value) => {
                    const f = statusArray.find((s) => s.id === value);
                    return f ? f.status : 'Unknown';
                }
            });
        }
        // if (siteVehicleFilter === 'true' || statusFilter == '1') {
        tempCols.splice(0, 0, {
            field: '',
            title: 'Action',
            width: '70',
            renderer: handleEdit,
            filterable: false,
            sortable: false
        });
        // }
        return tempCols;
    }, [baseCols, history, state.isCollected]);

    const rowDataStyle = (record) => {
        return {
            ['background-color']: record.bgColor || 'white'
        };
    };
    const colDataStyle = (record) => {
        return {
            ['color']: record.txtColor || 'black'
        };
    };

    const handleYesNo = (name, val) => {
        setState((st) => ({
            ...st,
            [name]: val
            // url
        }));
    };

    return (
        <div className="tCard-screen-container">
            <Grid container>
                <Grid item xs={12}>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item>
                            <BreadCrumbs crumbs={crumbs} />
                        </Grid>
                        {!siteVehicleFilter && (
                            <Grid item>
                                <ButtonGroup disableElevation size="small" variant="contained" color="secondary">
                                    <Button variant={state.isCollected == 'A' ? 'contained' : 'outlined'} onClick={() => handleYesNo('isCollected', 'A')}>
                                        Active
                                    </Button>
                                    <Button variant={state.isCollected == 'C' ? 'contained' : 'outlined'} onClick={() => handleYesNo('isCollected', 'C')}>
                                        Collected
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        )}
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <ReportGijgoGrid
                        getUrl={state.url}
                        isReload={state.refreshGrid}
                        columns={columns}
                        dropDownListProvider={dropProvider}
                        FilterdParamsValues={{ StatusID: statusFilter }}
                        setRowStyleOnCondition={true}
                        setRowStyleFunction={rowDataStyle}
                        setColStyleOnCondition={true}
                        setColStyleFunction={colDataStyle}
                        AddBtn={addButton}
                        dataConverter={(res) => ({
                            records: (res?.data.dt || []).map((item) => ({
                                ...item,
                                StatusID: item.tCardsStatusID
                            })),
                            total: res?.data?.total
                        })}
                    />
                </Grid>

                {state.show && <TCardDashboardModal id={state.id} onClose={closeCommonModal} />}
                {state.customerModal.show && <CustomerDetailsModal accountNo={state.customerModal.accountNo} onClose={closeCustomerModal} />}
                {checkTcard.showCheckout && (
                    <DialogComp onClose={() => closeCheckout(false)} title={'Check-out Vehicle'} maxWidth="sm" fullWidth>
                        <AddcheckOut
                            tCardsID={checkTcard.tCardsID}
                            bookingDate={checkTcard.bookingDate}
                            selectedVehicle={checkTcard.selectedVehicle}
                            onClose={closeCheckout}
                        />
                    </DialogComp>
                )}
                {checkTcard.showCheckIn && (
                    <DialogComp onClose={() => closeCheckout(false)} title={'Check-In Vehicle'} maxWidth="sm" fullWidth>
                        <AddCheckIn tCardsID={checkTcard.tCardsID} selectedVehicle={checkTcard.selectedVehicle} onClose={closeCheckout} />
                    </DialogComp>
                )}
            </Grid>
        </div>
    );
}
